import { today } from "App/utils/helpers";

export const RESET_STATE_SEP = {
  nomor_surat_kontrol: "",
  nomor_sep: "",
  kode_dokter: null,
  nama_dokter: "Pilih Dokter",
  kode_poliklinik: null,
  nama_poliklinik: "Pilih Poliklinik",
  tgl_rencana_kontrol: today(),
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "noSuratKontrol",
    disablePadding: true,
    label: "NO KONTROL",
    sort: false,
    align: "left",
    minWidth: "150px",
  },

  {
    id: "tglRencanaKontrol",
    disablePadding: true,
    label: "TGL KONTROL",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "jnsPelayanan",
    disablePadding: true,
    label: "JENIS",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "nama",
    disablePadding: true,
    label: "NAMA",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "namaDokter",
    disablePadding: true,
    label: "DOKTER",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "namaPoliAsal",
    disablePadding: true,
    label: "POLI ASAL",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "namaPoliTujuan",
    disablePadding: true,
    label: "POLI TUJUAN",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "noKartu",
    disablePadding: true,
    label: "NO KARTU",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "noSepAsalKontrol",
    disablePadding: true,
    label: "NO SEP ASAL",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tglSEP",
    disablePadding: true,
    label: "TGL SEP",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tglTerbitKontrol",
    disablePadding: true,
    label: "TGL TERBIT",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
];

export const headCellsRujukInternal = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "no_rujuk_internal",
    disablePadding: true,
    label: "NO RUJUK INTERNAL",
    sort: false,
    align: "left",
    minWidth: "150px",
  },

  {
    id: "dokter_perujuk",
    disablePadding: true,
    label: "DOKTER PERUJUK",
    sort: false,
    align: "left",
    minWidth: "180px",
  },
  {
    id: "dokter_penerima_rujuk",
    disablePadding: true,
    label: "DOKTER PENERIMA RUJUK",
    sort: false,
    align: "left",
    minWidth: "180px",
  },
  {
    id: "spesialis",
    disablePadding: true,
    label: "SPESIALIS",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "konsul",
    disablePadding: true,
    label: "KONSUL",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "keterangan",
    disablePadding: true,
    label: "KETERANGAN",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "status_regis",
    disablePadding: true,
    label: "STATUS REGIS",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "inserted_date",
    disablePadding: true,
    label: "INSERT DATE",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "updated_date",
    disablePadding: true,
    label: "UPDATE DATE",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
];

export const headCellsListSEP = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "namaPeserta",
    disablePadding: true,
    label: "NAMA PESERTA",
    sort: false,
    align: "left",
    minWidth: "150px",
  },

  {
    id: "tglSep",
    disablePadding: true,
    label: "TGL SEP",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "poli",
    disablePadding: true,
    label: "POLI",
    sort: false,
    align: "left",
    minWidth: "150px",
  },

  {
    id: "kelasRawat",
    disablePadding: true,
    label: "KLS RAWAT",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "noKartu",
    disablePadding: true,
    label: "NO KARTU",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "noRujukan",
    disablePadding: true,
    label: "NO RUJUKAN",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "noSep",
    disablePadding: true,
    label: "NO SEP",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "ppkPelayanan",
    disablePadding: true,
    label: "PPK PELAYANAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
];
